import React from 'react';

import PublicEventComponent from '../components/public/event-public/index';

function PublicEvent() {
    return <PublicEventComponent />;
}

export default PublicEvent;
